import { render, staticRenderFns } from "./check-dragable-section.html?vue&type=template&id=3f5e6e2f&scoped=true&external"
import script from "./check-dragable-section.js?vue&type=script&lang=js&external"
export * from "./check-dragable-section.js?vue&type=script&lang=js&external"
import style0 from "./check-dragable-section.scss?vue&type=style&index=0&id=3f5e6e2f&prod&scoped=true&lang=scss&external"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f5e6e2f",
  null
  
)

export default component.exports